var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.prefixCls},[_c('img',{attrs:{"src":require("@/assets/image/favicon.png"),"alt":""}}),_c('span',{staticClass:"title"},[_vm._v("金鳌船艇")])])
}
var staticRenderFns = []

export { render, staticRenderFns }